import { useEffect, useState } from "react";
import { GetVoidProyectoColaborador, ProyectoColaboradorDTO } from "../../interfaces/ProyectosDTOS/ProyectoColaboradorDTO";
import CatalogService from "../../services/CatalogService";
import { IndexacionDTO } from "../../interfaces/IndexacionDTO";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { LoadingScreen } from "../Common/LoadingScreen";
import { FormColaborador } from "./ColaboradorForm";
import AlertService from "../../services/AlertService";

const catalogoService = new CatalogService();
const alertService = new AlertService();

interface Props {
    icolaboradores: Array<ProyectoColaboradorDTO>,
    token: any,
    idproy: number,
}

export const TablaColaboradoresProyecto: React.FC<Props> = ({ idproy, icolaboradores, token }) => {
    const [colaboradores, setColaboradores] = useState<Array<ProyectoColaboradorDTO>>(icolaboradores);
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState<Array<IndexacionDTO>>([]);
    const [open, setOpen] = useState(false);
    const [colaborador, setColaborador] = useState<ProyectoColaboradorDTO>(GetVoidProyectoColaborador());

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setColaborador(GetVoidProyectoColaborador());
    };

    const handleResponse = () => {
        setOpen(false);
        alertService.alertaExito('Éxito','Espere mientras se recarga la pagina.')
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const fetchData = async () => {
        try {
            await catalogoService.GetRolInvestigadorActivo()
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        setRoles(data.listData);
                    }
                })
                .catch((error) => {
                    console.error(error)
                });
        } catch (error) {
            console.error('Error:', error);
        }
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return (
            <LoadingScreen />
        );
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Cédula</TableCell>
                            <TableCell>Nombre</TableCell>
                            <TableCell>Rol</TableCell>
                            <TableCell>Es Colaborador</TableCell>
                            <TableCell>Opciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {colaboradores.map((colaborador) => (
                            <TableRow key={colaborador.iddecinvproyectocolaboradores}>
                                <TableCell>{colaborador.cedula}</TableCell>
                                <TableCell>{colaborador.nombre}</TableCell>
                                <TableCell>{roles.find(x => x.codigo === colaborador.iddecinvrolinvestigador)?.descripcion}</TableCell>
                                <TableCell>{colaborador.escolabproyecto === 1 ? 'Si' : 'No'}</TableCell>
                                <TableCell>
                                    <Button
                                        style={{ width: '50%', borderRadius: '25px' }}
                                        variant="contained"
                                        onClick={() => {
                                            setColaborador(colaborador);
                                            handleOpen();
                                        }}
                                    >
                                        Editar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Colaborador</DialogTitle>
                <DialogContent>
                    <FormColaborador idproy={idproy} personal={colaborador} token={token} onResponse={handleResponse} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}